var _ellipse, _circle, _circle2, _circle3, _line, _line2, _line3, _line4, _line5, _line6, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLines(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 155,
    viewBox: "0 0 228 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 113,
    cy: 150.993,
    rx: 80,
    ry: 3.7664,
    fill: "url(#paint0_radial)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.2256,
    cy: 52.0166,
    r: 5,
    stroke: "#246EFF",
    strokeOpacity: 0.4,
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.1206,
    cy: 4.12158,
    r: 2.89502,
    stroke: "#246EFF",
    strokeOpacity: 0.4,
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 223.899,
    cy: 126.122,
    r: 2.89502,
    stroke: "#246EFF",
    strokeOpacity: 0.4,
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3.9375,
    y1: 85.6865,
    x2: 3.9375,
    y2: 91.6865,
    stroke: "#A7C5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 88.9365,
    x2: 1,
    y2: 88.9365,
    stroke: "#A7C5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 209.187,
    y1: 27.4365,
    x2: 209.188,
    y2: 33.4365,
    stroke: "#A7C5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 212.25,
    y1: 30.6865,
    x2: 206.25,
    y2: 30.6865,
    stroke: "#A7C5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 149.953,
    y1: 11.0493,
    x2: 149.953,
    y2: 17.0493,
    stroke: "#A7C5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 153.016,
    y1: 14.2993,
    x2: 147.016,
    y2: 14.2993,
    stroke: "#A7C5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M175.193 49.8711H52.7404C51.7095 49.8711 50.8738 50.2734 50.8738 50.7696V64.7236C50.8738 65.2198 51.7095 65.6221 52.7404 65.6221H175.193C176.223 65.6221 177.059 65.2198 177.059 64.7236V50.7696C177.059 50.2734 176.223 49.8711 175.193 49.8711Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M159.558 56.6163H64.5921C63.3669 56.6163 62.3738 57.2521 62.3738 58.0364C62.3738 58.8207 63.3669 59.4565 64.5921 59.4565H159.558C160.783 59.4565 161.777 58.8207 161.777 58.0364C161.777 57.2521 160.783 56.6163 159.558 56.6163Z",
    fill: "#DDE4EE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3937 56.1951C55.9132 56.1951 56.3343 55.8021 56.3343 55.3174C56.3343 54.8326 55.9132 54.4397 55.3937 54.4397C54.8742 54.4397 54.4531 54.8326 54.4531 55.3174C54.4531 55.8021 54.8742 56.1951 55.3937 56.1951Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9643 56.1951C59.4837 56.1951 59.9048 55.8021 59.9048 55.3174C59.9048 54.8326 59.4837 54.4397 58.9643 54.4397C58.4448 54.4397 58.0237 54.8326 58.0237 55.3174C58.0237 55.8021 58.4448 56.1951 58.9643 56.1951Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8144 56.1951C52.3338 56.1951 52.7549 55.8021 52.7549 55.3174C52.7549 54.8326 52.3338 54.4397 51.8144 54.4397C51.2949 54.4397 50.8738 54.8326 50.8738 55.3174C50.8738 55.8021 51.2949 56.1951 51.8144 56.1951Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M175.326 68.9355H61.6378C60.6807 68.9355 59.9048 69.3378 59.9048 69.834V83.788C59.9048 84.2843 60.6807 84.6865 61.6378 84.6865H175.326C176.283 84.6865 177.059 84.2843 177.059 83.788V69.834C177.059 69.3378 176.283 68.9355 175.326 68.9355Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M160.811 75.6808H72.6413C71.5039 75.6808 70.5818 76.3166 70.5818 77.1008C70.5818 77.8851 71.5039 78.5209 72.6413 78.5209H160.811C161.948 78.5209 162.87 77.8851 162.87 77.1008C162.87 76.3166 161.948 75.6808 160.811 75.6808Z",
    fill: "#DDE4EE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1013 75.2595C64.5836 75.2595 64.9746 74.8666 64.9746 74.3818C64.9746 73.8971 64.5836 73.5042 64.1013 73.5042C63.619 73.5042 63.228 73.8971 63.228 74.3818C63.228 74.8666 63.619 75.2595 64.1013 75.2595Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4162 75.2595C67.8985 75.2595 68.2895 74.8666 68.2895 74.3818C68.2895 73.8971 67.8985 73.5042 67.4162 73.5042C66.9339 73.5042 66.543 73.8971 66.543 74.3818C66.543 74.8666 66.9339 75.2595 67.4162 75.2595Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M60.778 75.2595C61.2603 75.2595 61.6513 74.8666 61.6513 74.3818C61.6513 73.8971 61.2603 73.5042 60.778 73.5042C60.2958 73.5042 59.9048 73.8971 59.9048 74.3818C59.9048 74.8666 60.2958 75.2595 60.778 75.2595Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M175.193 87.9995H52.7404C51.7095 87.9995 50.8738 88.4018 50.8738 88.898V102.852C50.8738 103.348 51.7095 103.75 52.7404 103.75H175.193C176.223 103.75 177.059 103.348 177.059 102.852V88.898C177.059 88.4018 176.223 87.9995 175.193 87.9995Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M159.558 94.7448H64.5921C63.3669 94.7448 62.3738 95.3805 62.3738 96.1648C62.3738 96.9491 63.3669 97.5849 64.5921 97.5849H159.558C160.783 97.5849 161.777 96.9491 161.777 96.1648C161.777 95.3805 160.783 94.7448 159.558 94.7448Z",
    fill: "#DDE4EE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3937 94.3235C55.9132 94.3235 56.3343 93.9305 56.3343 93.4458C56.3343 92.9611 55.9132 92.5681 55.3937 92.5681C54.8742 92.5681 54.4531 92.9611 54.4531 93.4458C54.4531 93.9305 54.8742 94.3235 55.3937 94.3235Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9643 94.3235C59.4837 94.3235 59.9048 93.9305 59.9048 93.4458C59.9048 92.9611 59.4837 92.5681 58.9643 92.5681C58.4448 92.5681 58.0237 92.9611 58.0237 93.4458C58.0237 93.9305 58.4448 94.3235 58.9643 94.3235Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8144 94.3235C52.3338 94.3235 52.7549 93.9305 52.7549 93.4458C52.7549 92.9611 52.3338 92.5681 51.8144 92.5681C51.2949 92.5681 50.8738 92.9611 50.8738 93.4458C50.8738 93.9305 51.2949 94.3235 51.8144 94.3235Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M175.535 107.063H75.5399C74.6981 107.063 74.0156 107.466 74.0156 107.962V121.916C74.0156 122.412 74.6981 122.814 75.5399 122.814H175.535C176.377 122.814 177.059 122.412 177.059 121.916V107.962C177.059 107.466 176.377 107.063 175.535 107.063Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M162.768 113.809H85.218C84.2175 113.809 83.4065 114.444 83.4065 115.229C83.4065 116.013 84.2175 116.649 85.2179 116.649H162.768C163.768 116.649 164.579 116.013 164.579 115.229C164.579 114.444 163.768 113.809 162.768 113.809Z",
    fill: "#DDE4EE"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7066 113.387C78.1308 113.387 78.4746 112.994 78.4746 112.51C78.4746 112.025 78.1308 111.632 77.7066 111.632C77.2824 111.632 76.9385 112.025 76.9385 112.51C76.9385 112.994 77.2824 113.387 77.7066 113.387Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6223 113.387C81.0465 113.387 81.3904 112.994 81.3904 112.51C81.3904 112.025 81.0465 111.632 80.6223 111.632C80.1981 111.632 79.8542 112.025 79.8542 112.51C79.8542 112.994 80.1981 113.387 80.6223 113.387Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7837 113.387C75.2079 113.387 75.5518 112.994 75.5518 112.51C75.5518 112.025 75.2079 111.632 74.7837 111.632C74.3595 111.632 74.0156 112.025 74.0156 112.51C74.0156 112.994 74.3595 113.387 74.7837 113.387Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M175.193 126.122H52.7404C51.7095 126.122 50.8738 126.524 50.8738 127.02V140.974C50.8738 141.47 51.7095 141.873 52.7404 141.873H175.193C176.223 141.873 177.059 141.47 177.059 140.974V127.02C177.059 126.524 176.223 126.122 175.193 126.122Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M159.558 132.867H64.5921C63.3669 132.867 62.3738 133.503 62.3738 134.287C62.3738 135.071 63.3669 135.707 64.5921 135.707H159.558C160.783 135.707 161.777 135.071 161.777 134.287C161.777 133.503 160.783 132.867 159.558 132.867Z",
    fill: "#DDE4EE"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3937 132.446C55.9132 132.446 56.3343 132.053 56.3343 131.568C56.3343 131.083 55.9132 130.69 55.3937 130.69C54.8742 130.69 54.4531 131.083 54.4531 131.568C54.4531 132.053 54.8742 132.446 55.3937 132.446Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9643 132.446C59.4837 132.446 59.9048 132.053 59.9048 131.568C59.9048 131.083 59.4837 130.69 58.9643 130.69C58.4448 130.69 58.0237 131.083 58.0237 131.568C58.0237 132.053 58.4448 132.446 58.9643 132.446Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8144 132.446C52.3338 132.446 52.7549 132.053 52.7549 131.568C52.7549 131.083 52.3338 130.69 51.8144 130.69C51.2949 130.69 50.8738 131.083 50.8738 131.568C50.8738 132.053 51.2949 132.446 51.8144 132.446Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.3738,
    y: 39.157,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0879 39.157C48.7711 39.157 46.5063 39.844 44.5799 41.1312C42.6535 42.4183 41.1521 44.2478 40.2655 46.3883C39.3789 48.5288 39.1469 50.8841 39.5989 53.1564C40.0509 55.4287 41.1665 57.516 42.8048 59.1542C44.443 60.7925 46.5303 61.9081 48.8026 62.3601C51.0749 62.8121 53.4302 62.5801 55.5707 61.6935C57.7112 60.8069 59.5406 59.3055 60.8278 57.3791C62.115 55.4527 62.802 53.1879 62.802 50.8711C62.7929 47.7671 61.5558 44.7929 59.361 42.598C57.1661 40.4032 54.1919 39.1661 51.0879 39.157Z",
    fill: "#56D187"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5165 44.8711H50.6593C50.3437 44.8711 50.0879 45.2293 50.0879 45.6711V56.0711C50.0879 56.5129 50.3437 56.8711 50.6593 56.8711H51.5165C51.8321 56.8711 52.0879 56.5129 52.0879 56.0711V45.6711C52.0879 45.2293 51.8321 44.8711 51.5165 44.8711Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0879 51.2997V50.4425C57.0879 50.1269 56.7413 49.8711 56.3137 49.8711H45.8621C45.4345 49.8711 45.0879 50.1269 45.0879 50.4425V51.2997C45.0879 51.6153 45.4345 51.8711 45.8621 51.8711H56.3137C56.7413 51.8711 57.0879 51.6153 57.0879 51.2997Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113 150.993) rotate(90) scale(3.7664 80)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6ECF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6ECF7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.3738,
    y: 39.157,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLines);
export default __webpack_public_path__ + "static/media/lines.c22a822aea19a9505708c1c55419cc50.svg";
export { ForwardRef as ReactComponent };